import Cookies from 'js-cookie'
import {DOMAIN} from '@/config'
let domain = DOMAIN
const accountKey = 'login-account'
const originKey = 'login-origin'
const FOXCONN_DOMAIN = 'genergy.top'
const FOXCONN_DOMAIN_NAME = 'genergy'
const PASSWORD_EXCEPTION = 'passwordException' // 用户密码状态 密码是否异常：PX0000:正常，PX0001:格式有误，PX0002:密码使用超过有效期
const isFoxconn = window.location.hostname.includes(FOXCONN_DOMAIN_NAME)

domain = isFoxconn ? FOXCONN_DOMAIN : domain

export function setPasswordException (passwordException) {
  if (process.env.NODE_ENV === 'development') {
    Cookies.set(PASSWORD_EXCEPTION, passwordException)
  } else {
    Cookies.set(PASSWORD_EXCEPTION, passwordException, { domain })
  }
}
export function removePasswordException () {
  if (process.env.NODE_ENV === 'development') {
    Cookies.remove(PASSWORD_EXCEPTION)
  } else {
    Cookies.remove(PASSWORD_EXCEPTION, { domain })
  }
}

/**
 * 获取密码状态
 * @returns
 */
export function getPasswordException () {
  if (process.env.NODE_ENV === 'development') {
    return Cookies.get(PASSWORD_EXCEPTION)
  } else {
    return Cookies.get(PASSWORD_EXCEPTION, { domain })
  }
}

export function getAccount () {
  if (process.env.NODE_ENV === 'development') {
    return Cookies.get(accountKey)
  } else {
    return Cookies.get(accountKey, { domain })
  }
}

export function setAccount (token) {
  if (process.env.NODE_ENV === 'development') {
    Cookies.set(accountKey, token)
  } else {
    Cookies.set(accountKey, token, { domain })
  }
}

export function removeAccount () {
  if (process.env.NODE_ENV === 'development') {
    Cookies.remove(accountKey)
  } else {
    Cookies.remove(accountKey)
    Cookies.remove(accountKey, { domain })
  }
}

export function getOrigin () {
  if (process.env.NODE_ENV === 'development') {
    return Cookies.get(originKey)
  } else {
    return Cookies.get(originKey, { domain })
  }
}

export function setOrigin (token) {
  if (process.env.NODE_ENV === 'development') {
    Cookies.set(originKey, token)
  } else {
    Cookies.set(originKey, token, { domain })
  }
}

export function removeOrigin () {
  if (process.env.NODE_ENV === 'development') {
    Cookies.remove(originKey)
  } else {
    Cookies.remove(originKey, { domain })
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js